import gql from 'graphql-tag';
import { profileFragment } from './fragments';

/*
*
*/
export const profiles = gql`
  query profiles($where: ProfileWhereInput, $orderBy: ProfileOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    profiles(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${profileFragment}
  }
`;
